import React from 'react';
import { ProfileContactFields } from './ProfileContactFields';
import { ProfileCitiesSelector } from './ProfileCitiesSelector';
import { ProfileZonesSelector } from './ProfileZonesSelector';

export const TIPO_DOCS = [
  'Cédula de Ciudadanía',
  'Cédula de Extranjería',
  'Pasaporte',
  'Permiso Especial de Permanencia',
];

interface EditProfileFormFieldsProps {
  formData: {
    nombreCompleto: string;
    celular: string;
    tipoIdentificacion: string;
    numeroIdentificacion: string;
    email?: string;
    commercializationCities: string[];
    commercializationZones: Record<string, string[]>;
  };
  email?: string;
  onChange: (field: string, value: string) => void;
  tipoDocs?: string[];
  editableFields: Record<string, boolean>;
  onToggleEditField: (field: string) => void;
  onCloseEditField?: (field: string) => void;
  onToggleCity: (city: string) => void;
  onToggleZone: (city: string, zone: string) => void;
  onSelectAllZones: (city: string) => void;
  onClearZones: (city: string) => void;
}

export const EditProfileFormFields: React.FC<EditProfileFormFieldsProps> = ({
  formData,
  email,
  onChange,
  tipoDocs = TIPO_DOCS,
  editableFields,
  onToggleEditField,
  onCloseEditField,
  onToggleCity,
  onToggleZone,
  onSelectAllZones,
  onClearZones,
}) => {
  return (
    <div className="space-y-6">
      <ProfileContactFields
        nombreCompleto={formData.nombreCompleto}
        celular={formData.celular}
        tipoIdentificacion={formData.tipoIdentificacion}
        numeroIdentificacion={formData.numeroIdentificacion}
        email={email || formData.email}
        tipoDocs={tipoDocs}
        editableFields={editableFields}
        onChange={onChange}
        onToggleEditField={onToggleEditField}
      />

      <div className="space-y-4 pt-2 border-t border-slate-100">
        <h3 className="text-xs font-black text-slate-400 uppercase tracking-widest px-1">
          Zonas de Operación y Cobertura
        </h3>

        <ProfileCitiesSelector
          selectedCities={formData.commercializationCities}
          selectedZones={formData.commercializationZones}
          isEditing={!!editableFields.cities}
          onToggleEdit={() => onToggleEditField('cities')}
          onCloseEdit={() => onCloseEditField?.('cities')}
          onToggleCity={onToggleCity}
        />

        <ProfileZonesSelector
          selectedCities={formData.commercializationCities}
          selectedZones={formData.commercializationZones}
          isEditing={!!editableFields.zones}
          onToggleEdit={() => onToggleEditField('zones')}
          onCloseEdit={() => onCloseEditField?.('zones')}
          onToggleZone={onToggleZone}
          onSelectAllZones={onSelectAllZones}
          onClearZones={onClearZones}
        />
      </div>
    </div>
  );
};
